import React, { useState} from "react";
import ContinueButton from "../../Registration/ContinueButton";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { submitCompanyDetails, saveCompanyInfoToStore} from "../../store/buyerFormDataSlice";

const CompanyDetailsForm = ({ onNext }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.id);
  const companyDetails = useSelector((state) => state.buyerFormData.companyInfo); 
  const [formData, setFormData] = useState({
    company_name: companyDetails.companyName || "",
    organization_type: companyDetails.organizationType || "",
    other_organization_type: companyDetails.otherOrganizationType || "",
    company_size:companyDetails.companySize || "",
    industry_sector:companyDetails.industry || "",
  });

  const isDisabled =
    !formData.company_name ||
    !formData.company_size ||
    !formData.organization_type ||
    !formData.industry_sector;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "organization_type" && value !== "Other") {
      setFormData((prev) => ({ ...prev, other_organization_type: "" }));
    }
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData((prev) => ({ ...prev, [name]: selectedOption?.value || "" }));
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      textAlign: "start",
      background: "#F7F7F7",
      borderRadius: "0.5rem",
    }),
    control: (provided, state) => ({
      ...provided,
      border: "none",
      background: "#F9F9F9",
      textAlign: "start",
      height: "48px",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
        : provided.boxShadow,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1D2639",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "lightgray"
        : state.isFocused
        ? "lightgray"
        : provided.backgroundColor,
      color: "black",
      padding: "6px",
      borderRadius: "0.5rem",
      "&:active": {
        backgroundColor: "lightgray",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#B0B0B0",
    }),
  };

  const industryNames = [
    "Agriculture, Forestry, Fishing and Hunting",
    "Mining, Quarrying, and Oil and Gas Extraction",
    "Utilities",
    "Construction",
    "Manufacturing",
    "Wholesale Trade",
    "Retail Trade",
    "Transportation and Warehousing",
    "Information",
    "Finance and Insurance",
    "Real Estate and Rental and Leasing",
    "Professional, Scientific, and Technical Services",
    "Management of Companies and Enterprises",
    "Administrative and Support and Waste Management and Remediation Services",
    "Educational Services",
    "Health Care and Social Assistance",
    "Arts, Entertainment, and Recreation",
    "Accommodation and Food Services",
    "Other Services (except Public Administration)",
  ];

  const organizationTypes = [
    "Association",
    "Charitable Organization",
    "Church",
    "Cooperative",
    "Corporation",
    "Government Agency",
    "Limited Liability Company (LLC)",
    "Nonprofit Organization",
    "Partnership",
    "Political Organization",
    "Sole Proprietorship",
    "Other"
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const hasChanged = Object.keys(formData).some(
      (key) => formData[key] !== companyDetails?.[key]
    );
    if (!hasChanged) {
      onNext();
      return;  
    }

    const companyInfo = {
      companyName: formData.company_name,
      organizationType: formData.organization_type,
      otherOrganizationType: formData.other_organization_type || undefined,
      companySize: formData.company_size,
      industry: formData.industry_sector,
      createdBy: userId,
      accountType: "BUYER",
    };
  
    await dispatch(submitCompanyDetails(companyInfo));
    dispatch(saveCompanyInfoToStore(companyInfo));
    onNext();
  };
  
  

  return (
    <section className="flex flex-col min-h-screen justify-start items-center py-10 px-6">
      <header className="mb-14">
      <h3 className="text-xl font-medium text-[#7E7E7E] text-center">Step 2</h3>
        <h1 className="text-2xl font-semibold text-[#1D2639] text-center">Company Details</h1>
        <p className="text-base font-medium text-[#7E7E7E] text-center mt-2">
          Sharing your company's name, type, size, and industry sector helps us understand your organizational context, allowing us to connect you with suppliers that align with your operational scale and industry requirements.
        </p>
      </header>
      <form className="flex flex-col w-full sm:w-[572px]">
        {[
          { label: "Company Name", name: "company_name", type: "text", required: true },
          {
            label: "Organization Type",
            name: "organization_type",
            type: "select",
            options: organizationTypes,
            required: true,
          },
          { label: "Other Organization Type", name: "other_organization_type", type: "text" },
          {
            label: "Company Size",
            name: "company_size",
            type: "select",
            options: [
              "Micro (1-10 employees)",
              "Small (11-50 employees)",
              "Medium (51-250 employees)",
              "Large (251-500 employees)",
              "Enterprise (501-1000 employees)",
              "Corporate (1001-5000 employees)",
              "Global (5001+ employees)",
            ],
            required: true,
          },
          {
            label: "Industry",
            name: "industry_sector",
            type: "select",
            options: industryNames,
            required: true,
          },
        ].map(({ label, name, type, options, required }) => (
          <fieldset key={name} className="mb-8">
            <label className="block text-[#1D2639] text-[12px] text-start font-normal" htmlFor={name}>
              {label} {required && <span className="text-red-500">*</span>}
            </label>
            {type === "select" ? (
              <Select
                id={name}
                name={name}
                options={options.map((option) => ({ label: option, value: option }))}
                value={formData[name] ? { label: formData[name], value: formData[name] } : null}
                onChange={(selectedOption) => handleSelectChange(name, selectedOption)}
                placeholder={`Select ${label}`}
                isSearchable
                styles={customStyles}
              />
            ) : (
              <input
                type={type}
                id={name}
                name={name}
                placeholder={`Enter ${label}`}
                className="w-full h-12 p-3 bg-[#F9F9F9] rounded-lg border-2 border-gray-300"
                value={formData[name]}
                onChange={handleChange}
                required={required}
                disabled={name === "other_organization_type" && formData.organization_type !== "Other"}
              />
            )}
          </fieldset>
        ))}
        <ContinueButton onClick={handleSubmit} label="Save and Continue" isDisabled={isDisabled} />
      </form>
    </section>
  );
};

export default CompanyDetailsForm;
